module Core {

    export enum AccesStatus {
        HasAcces,
        NotAcces,
        Pending
    }

}